var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CaseTypes'),_c('MobileList',{attrs:{"typeId":_vm.caseType}}),_c('WebList',{attrs:{"typeId":_vm.caseType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }